export class User {
    id: number;
    username: string;
    name: string;
    surname: string;
  }
  